/* eslint-disable */

import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Search } from "react-feather";
import { all_routes } from "../../Router/all_routes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  ROLL_CALL_API_BASE_URL,
  FILESERVER_PATH,
} from "../../feature-module/Pereco/RollCall/RollCallConfig/RollCallConfig";
import { useDispatch } from "react-redux";
import { setDataLayout } from "../../core/redux/themeSettingSlice";
import Swal from "sweetalert2";
import { Popover } from "antd";

const Header = () => {
  const route = all_routes;
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [flagImage, setFlagImage] = useState("assets/img/flags/in.png");
  const { t, i18n } = useTranslation();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [userModules, setUserModules] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const moduleConfig = {
    Attendance: {
      icon: "ti ti-calendar",
      route: route.attendance || "#",
    },
    Visitor: {
      icon: "ti ti-calendar",
      route: route.visitor || "#",
    },
    Vistor: {
      icon: "ti ti-calendar",
      route: route.visitor || "#",
    },
  };

  const [popoverVisible, setPopoverVisible] = useState(false);
  const [selectedModuleId, setSelectedModuleId] = useState(
    Number(sessionStorage.getItem("selectedModuleId")) || null,
  );

  const handleModuleClick = (mod) => {
    sessionStorage.setItem("selectedModuleId", mod.Id);
    setSelectedModuleId(mod.Id);

    // Dispatch event to notify horizontalMenu
    window.dispatchEvent(new CustomEvent("moduleChange", { detail: mod.Id }));

    // Close popover
    setPopoverVisible(false);
  };

  const handleSelect = (location) => {
    setSelectedLocation(location);
  };

  const userData = JSON.parse(sessionStorage.getItem("userData"));

  const changeLanguage = (lng) => {
    // Debugging statement
    i18n.changeLanguage(lng);
    setFlagImage(
      lng === "en"
        ? "assets/img/flags/us-flag.svg"
        : lng === "fr"
          ? "assets/img/flags/fr.png"
          : lng === "es"
            ? "assets/img/flags/es.png"
            : "assets/img/flags/de.png",
    );
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found ");
      navigate("/signin");
    }
  }, [navigate]);

  const isElementVisible = (element) => {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };

  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);

    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []);

  useEffect(() => {
    const fetchNotificationData = async () => {
      if (tokenData && superIdData && userData?.UserId) {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/notification/getNotification?superid=${superIdData}&regid=${userData?.UserId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error("Failed to fetch employees");
          }

          const data = await response.json();
          if (data.status) {
            setData(data.ResultData || []);
          } else {
            console.error("Error fetching employees:", data.ErrorMsg);
          }
        } catch (error) {
          console.error("Error fetching employees:", error);
        } finally {
        }
      }
    };

    fetchNotificationData();
  }, [superIdData, tokenData, userData?.UserId]);

  useEffect(() => {
    const fetchModules = async () => {
      if (tokenData && superIdData && userData?.UserId) {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/org/GetModules?SuperId=${superIdData}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error("Failed to fetch modules");
          }

          const data = await response.json();
          if (data.status) {
            const modules = data.ResultData || [];
            setUserModules(modules);
            const defaultModule = modules.find(
              (module) => module.DefaultModule === true,
            );

            if (defaultModule) {
              sessionStorage.setItem(
                "selectedModuleId",
                defaultModule.Id.toString(),
              );
            }
          } else {
            console.error("Error fetching modules:", data?.ErrorMsg);
          }
        } catch (error) {
          console.error("Error fetching modules:", error);
        } finally {
        }
      }
    };

    fetchModules();
  }, [superIdData, tokenData, userData?.UserId]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement,
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange,
      );
    };
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("superId");
    sessionStorage.clear();

    navigate("/rollcall/signin");
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };
  console.log(toggle, "header toggle");
  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };
  // useEffect(() => {
  //   sidebarOverlay();
  // }, [location.pathname]);
  useEffect(() => {
    document.querySelector(".main-wrapper")?.classList?.remove("slide-nav");
    document.querySelector(".sidebar-overlay")?.classList?.remove("opened");
    document.querySelector("html")?.classList?.remove("menu-opened");
  }, [location.pathname]);
  let pathname = location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };
  const { expandMenus } = useSelector(
    (state) => state.themeSetting.expandMenus,
  );
  const dataLayout = useSelector((state) => state.themeSetting.dataLayout);

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const updateLayout = () => {
      const newLayout = window.innerWidth < 992 ? "default" : "horizontal";

      dispatch(setDataLayout(newLayout));
    };

    updateLayout();
    window.addEventListener("resize", updateLayout);

    return () => window.removeEventListener("resize", updateLayout);
  }, [dispatch]);

  const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes
  const RESPONSE_TIMEOUT = 2 * 60 * 1000; // 2 minutes

  const inactivityTimerRef = useRef(null);
  const responseTimerRef = useRef(null);

  const activityEvents = [
    "mousemove",
    "keydown",
    "scroll",
    "click",
    "touchstart",
  ];

  const clearAuth = () => {
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("superId");
    sessionStorage.removeItem("userMenu");
    sessionStorage.removeItem("userData");
    sessionStorage.removeItem("rollcall-permissions");
    sessionStorage.clear();

    navigate("/signin", { replace: true });
  };

  const startResponseTimer = () => {
    responseTimerRef.current = setTimeout(() => {
      Swal.close();
      clearAuth();
    }, RESPONSE_TIMEOUT);
  };

  const showSessionPopup = () => {
    startResponseTimer();

    Swal.fire({
      title: "Session Expiring",
      text: "Your session is about to expire. Do you want to continue?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Continue",
      cancelButtonText: "Logout",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      clearTimeout(responseTimerRef.current);

      if (result.isConfirmed) {
        resetTimer(); // reset 15 min timer
      } else {
        clearAuth(); // logout immediately
      }
    });
  };

  const resetTimer = () => {
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }

    inactivityTimerRef.current = setTimeout(() => {
      showSessionPopup();
    }, INACTIVITY_TIMEOUT);
  };

  useEffect(() => {
    if (!userData?.UserId) return;

    resetTimer();

    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer, { passive: true });
    });

    return () => {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
      if (responseTimerRef.current) {
        clearTimeout(responseTimerRef.current);
      }

      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [userData?.UserId]);

  const popoverContent = (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(80px, 1fr))",
        gap: "8px",
        width: "max-content",
        maxWidth: "480px",
        padding: "8px",
      }}
    >
      {[...(userModules || [])]
        .sort((a, b) => a.SortOrder - b.SortOrder)
        .map((mod) => {
          const config = moduleConfig[mod.ModuleName] || {};
          const isActive = selectedModuleId === mod.Id;

          return (
            <>
              <Link
                key={mod.Id}
                to={config.route}
                onClick={() => handleModuleClick(mod)}
                style={{
                  textAlign: "center",
                  padding: "6px 4px",
                  borderRadius: "6px",
                  fontSize: "12px",
                  textDecoration: "none",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  background: isActive ? "#e6f7ff" : "transparent", // active background
                }}
                className="module-item"
              >
                <div style={{ fontSize: "16px", marginBottom: "2px" }}>
                  <i className={config.icon || "ti ti-apps"} />
                </div>
                <div style={{ lineHeight: "14px" }}>{mod.ModuleName}</div>
              </Link>
            </>
          );
        })}
    </div>
  );
  return (
    <>
      {/* <div className="sidebar-overlay" onClick={sidebarOverlay} /> */}
      <div className="header">
        {/* Logo */}
        <div className="main-header">
          <div
            className={`header-left
             ${toggle ? "" : "active"}
             ${
               expandMenus || dataLayout === "layout-hovered"
                 ? "expand-menu"
                 : ""
             }
             `}
            onMouseLeave={expandMenu}
            onMouseOver={expandMenuOpen}
          >
            <Link to="/rollcall/dashboard" className="logo logo-normal mt-4">
              <ImageWithBasePath src="assets/img/logo.png" alt="img" />
            </Link>
            <Link to="/rollcall/dashboard" className="logo logo-white">
              <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
            </Link>
            <Link to="/rollcall/dashboard" className="logo-small">
              <ImageWithBasePath src="assets/img/logo-small.png" alt="img" />
            </Link>
            <Link
              id="toggle_btn"
              to="#"
              style={{
                display:
                  pathname.includes("tasks") || pathname.includes("pos")
                    ? "none"
                    : pathname.includes("compose")
                      ? "none"
                      : "",
              }}
              onClick={handlesidebar}
            >
              <FeatherIcon icon="chevrons-left" className="feather-16" />
            </Link>
          </div>
          {/* /Logo */}
          <Link
            id="mobile_btn"
            className="mobile_btn"
            to="#"
            onClick={sidebarOverlay}
          >
            <span className="bar-icon">
              <span />
              <span />
              <span />
            </span>
          </Link>
          {/* Header Menu */}
          <ul className="nav user-menu">
            {/* Search */}
            <li className="nav-item nav-searchinputs">
              {/* <div className="top-nav-search">
                <Link to="#" className="responsive-search">
                  <Search />
                </Link>
                <form action="#" className="dropdown">
                  <div
                    className="searchinputs input-group dropdown-toggle"
                    id="dropdownMenuClickable"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <input type="text" placeholder="Search" />
                    <div className="search-addon">
                      <span>
                        <i className="ti ti-search" />
                      </span>
                    </div>
                  </div>

                  <div
                    className="dropdown-menu search-dropdown"
                    aria-labelledby="dropdownMenuClickable"
                  >
                    <div className="search-info">
                      <h6>
                        <span>
                          <i data-feather="search" className="feather-16" />
                        </span>
                        Recent Searches
                      </h6>
                      <ul className="search-tags">
                        <li>
                          <Link to="#">Products</Link>
                        </li>
                        <li>
                          <Link to="#">Sales</Link>
                        </li>
                        <li>
                          <Link to="#">Applications</Link>
                        </li>
                      </ul>
                    </div>
                    <div className="search-info">
                      <h6>
                        <span>
                          <i
                            data-feather="help-circle"
                            className="feather-16"
                          />
                        </span>
                        Help
                      </h6>
                      <p>
                        How to Change Product Volume from 0 to 200 on Inventory
                        management
                      </p>
                      <p>Change Product Name</p>
                    </div>
                    <div className="search-info">
                      <h6>
                        <span>
                          <i data-feather="user" className="feather-16" />
                        </span>
                        Customers
                      </h6>
                      <ul className="customers">
                        <li>
                          <Link to="#">
                            Aron Varu
                            <ImageWithBasePath
                              src="assets/img/profiles/avator1.jpg"
                              alt
                              className="img-fluid"
                            />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            Jonita
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-01.jpg"
                              alt
                              className="img-fluid"
                            />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            Aaron
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-10.jpg"
                              alt
                              className="img-fluid"
                            />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </form>
              </div> */}
            </li>
            {/* /Search */}

            {/* Select Store */}
            <li className="nav-item dropdown has-arrow main-drop select-store-dropdown">
              {/* <Link
                to="#"
                className="dropdown-toggle nav-link select-store"
                data-bs-toggle="dropdown"
              >
                <span className="user-info">
                  <span className="user-letter">
                    <ImageWithBasePath
                      src="assets/img/store/store-01.png"
                      alt="Store Logo"
                      className="img-fluid"
                    />
                  </span>
                  <span className="user-detail">
                    <span className="user-name">Freshmart</span>
                  </span>
                </span>
              </Link> */}
              <div className="dropdown-menu dropdown-menu-right">
                <Link to="#" className="dropdown-item">
                  <ImageWithBasePath
                    src="assets/img/store/store-01.png"
                    alt="Store Logo"
                    className="img-fluid"
                  />
                  Freshmart
                </Link>
                <Link to="#" className="dropdown-item">
                  <ImageWithBasePath
                    src="assets/img/store/store-02.png"
                    alt="Store Logo"
                    className="img-fluid"
                  />
                  Grocery Apex
                </Link>
                <Link to="#" className="dropdown-item">
                  <ImageWithBasePath
                    src="assets/img/store/store-03.png"
                    alt="Store Logo"
                    className="img-fluid"
                  />
                  Grocery Bevy
                </Link>
                <Link to="#" className="dropdown-item">
                  <ImageWithBasePath
                    src="assets/img/store/store-04.png"
                    alt="Store Logo"
                    className="img-fluid"
                  />
                  Grocery Eden
                </Link>
              </div>
            </li>
            {/* Flag */}
            <li className="nav-item dropdown has-arrow flag-nav nav-item-box">
              <div className="dropdown-menu dropdown-menu-right">
                <Link
                  to="#"
                  className="dropdown-item active"
                  onClick={() => changeLanguage("en")}
                >
                  <ImageWithBasePath
                    src="assets/img/flags/english.svg"
                    alt="img"
                    height={16}
                  />
                  {t("English")}
                </Link>
                <Link
                  to="#"
                  className="dropdown-item"
                  onClick={() => changeLanguage("fr")}
                >
                  <ImageWithBasePath
                    src="assets/img/flags/arabic.svg"
                    alt="img"
                    height={16}
                  />{" "}
                  Arabic
                </Link>
              </div>
            </li>
            <li className="nav-item dropdown nav-item-box d-none">
              <div className="dropdown">
                <button
                  className="btn btn-outline-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fa-solid fa-location-dot me-2"></i>
                  {selectedLocation ? selectedLocation : "Select Location"}
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleSelect("Kukatpally")}
                    >
                      <i className="fa-solid fa-location-dot me-2"></i>
                      Kukatpally
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleSelect("Moula Ali")}
                    >
                      <i className="fa-solid fa-location-dot me-2"></i>Moula Ali
                    </button>
                  </li>
                </ul>
              </div>
            </li>

            <li className="nav-item dropdown link-nav">
              <Popover
                content={popoverContent}
                trigger="click"
                placement="bottom"
                visible={popoverVisible}
                onVisibleChange={(v) => setPopoverVisible(v)}
                overlayStyle={{ width: "fit-content" }}
              >
                <div className="btn btn-primary btn-md d-inline-flex align-items-center">
                  <i className="ti ti-layout-grid me-1" />
                  Modules
                </div>
              </Popover>
            </li>

            {/* /Flag */}
            <li className="nav-item nav-item-box">
              <Link
                to="#"
                id="btnFullscreen"
                onClick={() => toggleFullscreen()}
                className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
              >
                {/* <i data-feather="maximize" /> */}
                <i className="ti ti-maximize"></i>
              </Link>
            </li>
            {/* <li className="nav-item nav-item-box">
              <Link to="/email">
                <i className="ti ti-mail"></i>
                <span className="badge rounded-pill">1</span>
              </Link>
            </li> */}
            {/* Notifications */}
            <li className="nav-item dropdown nav-item-box">
              <Link
                to="#"
                className="dropdown-toggle nav-link"
                data-bs-toggle="dropdown"
              >
                <i
                  className="fa-solid fa-question fa-bounce"
                  style={{ color: "#75736c" }}
                ></i>
              </Link>
              <div className="dropdown-menu notifications">
                <div className="topnav-dropdown-header text-center">
                  <span className="notification-title text-center">
                    Helpful Videos
                  </span>
                </div>
                <div className="noti-content h-auto">
                  <ul className="notification-list">
                    <li className="notification-message">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <i
                            className="fa-brands fa-youtube fs-4"
                            style={{ color: "#f61313" }}
                          ></i>
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">
                              Rollcall Attendance Software
                            </span>
                            <a
                              href="https://www.youtube.com/watch?v=-a0jjcc1Y-k"
                              target="_blank"
                              rel="noreferrer"
                              className="text-info"
                              style={{
                                marginTop: "-1rem",
                                marginLeft: "-0.8rem",
                              }}
                            >
                              Watch the Demo
                            </a>
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className="notification-message">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <i
                            className="fa-brands fa-youtube fs-4"
                            style={{ color: "#f61313" }}
                          ></i>
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">iBizAccounts</span>
                            <a
                              href="https://www.youtube.com/watch?v=e6Npd_cy4JQ"
                              target="_blank"
                              rel="noreferrer"
                              className="text-info"
                              style={{
                                marginTop: "-1rem",
                                marginLeft: "-0.8rem",
                              }}
                            >
                              Watch the Demo
                            </a>
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li className="nav-item dropdown nav-item-box">
              <Link
                to="#"
                className="dropdown-toggle nav-link"
                data-bs-toggle="dropdown"
              >
                <i className="ti ti-bell"></i>
                {data?.length > 0 && (
                  <span className="badge rounded-pill">{data?.length}</span>
                )}
              </Link>
              <div className="dropdown-menu notifications">
                <div className="topnav-dropdown-header">
                  <h5 className="notification-title">Notifications</h5>
                  <Link to="#" className="clear-noti">
                    Mark all as read
                  </Link>
                </div>
                <div className="noti-content">
                  <ul className="notification-list">
                    {data?.length > 0 ? (
                      data.map((item, index) => (
                        <li
                          className="notification-message"
                          key={item.ID || index}
                        >
                          <Link to={route.rollcallnotification}>
                            <div className="media d-flex">
                              <span className="avatar flex-shrink-0">
                                <ImageWithBasePath
                                  alt="Img"
                                  src="assets/img/profiles/avatar-13.jpg"
                                />
                              </span>
                              <div className="flex-grow-1">
                                <p className="noti-details">
                                  <span className="noti-title">
                                    {item.Name}
                                  </span>{" "}
                                  – {item.Description}
                                </p>
                                <p className="noti-time">
                                  {new Date(item.CreatedOn).toLocaleString()}
                                </p>
                              </div>
                            </div>
                          </Link>
                        </li>
                      ))
                    ) : (
                      <li className="notification-message text-center">
                        No notifications found
                      </li>
                    )}
                  </ul>
                </div>
                <div className="topnav-dropdown-footer d-flex align-items-center gap-3">
                  <Link to="#" className="btn btn-secondary btn-md w-100">
                    Cancel
                  </Link>
                  <Link
                    to={route.rollcallnotification}
                    className="btn btn-primary btn-md w-100"
                  >
                    View all
                  </Link>
                </div>
              </div>
            </li>
            {/* 
            <li className="nav-item nav-item-box">
              <Link to="/rollcall/settings">
                <i className="ti ti-settings"></i>
              </Link>
            </li> */}
            <li className="nav-item dropdown has-arrow main-drop profile-nav">
              <Link
                to="#"
                className="nav-link userset"
                data-bs-toggle="dropdown"
              >
                <span className="user-info p-0">
                  <span className="user-letter">
                    <img
                      src={`${FILESERVER_PATH}/${userData?.LogoPath}`}
                      alt="Img"
                      className="img-fluid"
                    />
                  </span>
                </span>
              </Link>
              <div
                className="dropdown-menu menu-drop-user"
                style={{ width: "260px" }}
              >
                <div className="profileset d-flex align-items-center">
                  <span className="user-img me-2">
                    <img
                      src={`${FILESERVER_PATH}/${userData?.LogoPath}`}
                      alt="Img"
                    />
                  </span>
                  <div>
                    <h6 className="fw-medium"> {userData?.Organization}</h6>
                    <p> {userData?.UserName?.slice(0, 8)} (Admin)</p>
                  </div>
                </div>
                {/* <Link className="dropdown-item" to={route.profile}>
                  <i className="ti ti-user-circle me-2" />
                  MyProfile
                </Link> */}
                {/* <Link className="dropdown-item" to={route.salesreport}>
                  <i className="ti ti-file-text me-2" />
                  Reports
                </Link>*/}
                <Link className="dropdown-item" to="/rollcall/settings">
                  <i className="ti ti-settings-2 me-2" />
                  Settings
                </Link>
                <hr className="my-2" />
                <a className="dropdown-item logout pb-0" onClick={handleLogout}>
                  <i className="ti ti-logout me-2" />
                  Logout
                </a>
              </div>
            </li>
          </ul>
          {/* /Header Menu */}
          {/* Mobile Menu */}
          <div className="dropdown mobile-user-menu">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v" />
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              {/* <Link className="dropdown-item" to="profile">
                My Profile
              </Link> */}
              <Link className="dropdown-item" to="/rollcall/settings">
                <i className="ti ti-settings-2 me-2" />
                Settings
              </Link>
              <Link className="dropdown-item" onClick={handleLogout}>
                <i className="ti ti-logout me-2" /> Logout
              </Link>
            </div>
          </div>
          {/* /Mobile Menu */}
        </div>
      </div>
    </>
  );
};

export default Header;
